import * as React from 'react';
import themePrimary from '../../styles/themePrimary';
import { Typography, makeStyles, useMediaQuery, Dialog, Slide } from '@material-ui/core';
import { UserStateContext } from '../../providers/UserStateContextProvider';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import { TransitionProps } from '@material-ui/core/transitions';
import PhoneTextField, { PhoneTextFieldChangeHandler, PhoneTextFieldProps } from '../common/PhoneTextField';
import { isValidPhoneNumber } from 'react-phone-number-input';
import TextField, { TextFieldProps, TextFieldLabelPosition, TextFieldChangeHandler } from '../common/TextField';
import { String_CheckOut_PhoneLabel, String_CheckOut_EmailLabel, String_System_ErrorInvalidEmail, String_System_ErrorInvalidPhone, String_3DSDialog_Instruction, String_System_Done, String_CheckOut_PostalCodeLabel, String_CheckOut_CityLabel, String_CheckOut_AddressLabel, String_System_ErrorPostalCodeRequired, String_System_ErrorCityRequired, String_System_ErrorAddressRequired } from '../../utilities/StringHelper';
import { ElementDimensions } from '../../styles/ElementDimensions'
import SmallButton, { SmallButtonProps } from '../common/Buttons/SmallButton';

const useStyles = makeStyles({
    button: {
        marginTop: '20px',
    },
    buttonContainer: {
        padding: ElementDimensions.padding10 + 'px',
    },
    details: {
        padding: '10px',
    },
    dialog: {
        backgroundColor: themePrimary.palette.secondary.light,
    },
    dialogLandscape: {
        backgroundColor: themePrimary.palette.secondary.light,
        left: 'calc(100vw *.3) !important',
        width: 'calc(100vw *.7)',
    },
    errorMessageContainer: {
        marginLeft: 'auto',
        marginRight: 'auto',
        textAlign: 'center',
        height: '2em'
    },
    errorMessage: {
        fontSize: '1rem',
        color: themePrimary.palette.error.main,
        fontFamily: 'LeagueSpartan-Regular !important',
    },
    instructionText: {
        marginTop: ElementDimensions.margin10 + 'px',
        marginBottom: ElementDimensions.margin20 + 'px',
        textAlign: 'center',
        fontFamily: 'LeagueSpartan-Regular !important',
    },
    textFieldOuterContainer: {
        display: 'flex',
    },
    textFieldInnerContainer: {
        textAlign: 'left',
        marginLeft: '30px',
        marginRight: 'auto',
    },
});

export type ThreeDSErrorHandler = () => any;
export type ThreeDSDoneHandler = (address: string, city: string, postalCode: string, 
        emailAddress: string, phoneNumber: string, country: string, nationalPhoneNumber: string, countryCode: string) => any;

export interface ThreeDSProps {
    open: boolean;
    doneButtonClicked: boolean;
    onDoneHandler: ThreeDSDoneHandler;
    onErrorHandler: ThreeDSErrorHandler;
}

const ThreeDs = (props: ThreeDSProps) => {
    const { open, doneButtonClicked, onDoneHandler, onErrorHandler } = props;
    const [isAddressError, setIsAddressError] = React.useState<boolean>(false);
    const [isCityError, setIsCityError] = React.useState<boolean>(false);
    const [isPostalCodeError, setIsPostalCodeError] = React.useState<boolean>(false);
    const [isEmailError, setIsEmailError] = React.useState<boolean>(false);
    const [isPhoneError, setIsPhoneError] = React.useState<boolean>(false);
    const [address, setAddress] = React.useState<string>('');
    const [city, setCity] = React.useState<string>('');
    const [postalCode, setPostalCode] = React.useState<string>('');
    const [emailAddress, setEmailAddress] = React.useState<string>('');
    const [phoneNumber, setPhoneNumber] = React.useState<string>('');
    const [nationalPhoneNumber, setNationalPhoneNumber] = React.useState<string>('');
    const [country, setCountry] = React.useState<string>('');
    const [countryCode, setCountryCode] = React.useState<string>('');
    const isPortrait = true;
    const userState = React.useContext(UserStateContext);
    const checkOutState = React.useContext(CheckOutStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });

    React.useEffect(() => {
        
        var test = checkOutState.state.restaurantCountry
        if (doneButtonClicked) {
            handleDoneButtonClick();
        }
    },[doneButtonClicked]);

    const handleAddressChange: TextFieldChangeHandler = (newValue: string) => {
        setAddress(newValue.trim());
        setIsAddressError(false);
    };

    const addressTextFieldProps: TextFieldProps = {
        type: null,
        label: String_CheckOut_AddressLabel.find(s => s.key === userState.state.locale)!!.value,
        text: address,
        width: 300,
        disabled: false,
        labelPosition: TextFieldLabelPosition.Top,
        onChangeHandler: handleAddressChange,
    }

    const handleCityChange: TextFieldChangeHandler = (newValue: string) => {
        setCity(newValue.trim());
        setIsCityError(false);
    };

    const cityTextFieldProps: TextFieldProps = {
        type: null,
        label: String_CheckOut_CityLabel.find(s => s.key === userState.state.locale)!!.value,
        text: city,
        width: 300,
        disabled: false,
        labelPosition: TextFieldLabelPosition.Top,
        onChangeHandler: handleCityChange,
    }

    const handlePostalCodeChange: TextFieldChangeHandler = (newValue: string) => {
        setPostalCode(newValue.trim());
        setIsPostalCodeError(false);
    };

    const postalCodeTextFieldProps: TextFieldProps = {
        type: null,
        label: String_CheckOut_PostalCodeLabel.find(s => s.key === userState.state.locale)!!.value,
        text: postalCode,
        width: 150,
        disabled: false,
        labelPosition: TextFieldLabelPosition.Top,
        onChangeHandler: handlePostalCodeChange,
    }

    const handleEmailAddressChange: TextFieldChangeHandler = (newValue: string) => {
        setEmailAddress(newValue.trim());
        setIsEmailError(false);
    };

    const emailProps: TextFieldProps = {
        type: null,
        label: String_CheckOut_EmailLabel.find(s => s.key === userState.state.locale)!!.value,
        text: emailAddress,
        width: 300,
        disabled: false,
        labelPosition: TextFieldLabelPosition.Top,
        onChangeHandler: handleEmailAddressChange,
    }

    const handlePhoneChange: PhoneTextFieldChangeHandler = (newValue: string, country: string, nationalPhoneNumber: string, countryCode: string) => {
        setPhoneNumber(newValue);
        setCountry(country);
        setNationalPhoneNumber(nationalPhoneNumber)
        setCountryCode(countryCode);
        setIsPhoneError(false);
    };

    const phoneTextFieldProps: PhoneTextFieldProps = {
        country: checkOutState.state.restaurantCountry,
        label: String_CheckOut_PhoneLabel.find(s => s.key === userState.state.locale)!!.value,
        type: null,
        text: phoneNumber === undefined ? "" : phoneNumber,
        width: 160,
        disabled: false,
        labelPosition: TextFieldLabelPosition.Top,
        onChangeHandler: handlePhoneChange,
    };

    const handleDoneButtonClick = () => {
        var hasError: boolean = false;

        if (address.trim() === "") {
            hasError = true;
            setIsAddressError(true);
        }

        if (city.trim() === "") {
            hasError = true;
            setIsCityError(true);
        }

        if (postalCode.trim() === "") {
            hasError = true;
            setIsPostalCodeError(true);
        }

        if (!(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(emailAddress.trim()))) {
            hasError = true;
            setIsEmailError(true);            
        }     

        if (phoneNumber !== undefined && country !== undefined && nationalPhoneNumber !== undefined && countryCode !== undefined) {
            if (!isValidPhoneNumber(phoneNumber.trim())) {
                hasError = true;
                setIsPhoneError(true);
            }
        }
        else {
            hasError = true;
            setIsPhoneError(true);
        }
        
        if (!hasError) {
            onDoneHandler(address.trim(), city.trim(), postalCode.trim(), emailAddress.trim(), phoneNumber!!.trim(), 
                country!!.trim(), nationalPhoneNumber!!.trim(), countryCode!!.trim());
            setAddress('');
            setCity('');
            setPostalCode('');
            setEmailAddress('');
            setPhoneNumber('');
            setCountry('');
            setNationalPhoneNumber('');
            setCountryCode('');
        }
        else {
            onErrorHandler();
        }
    }

    return (
        <div className={classes.details}>
            <Typography variant="h6" className={classes.instructionText}>
                {String_3DSDialog_Instruction.find(s => s.key === userState.state.locale)!!.value}
            </Typography>


            <div className={classes.textFieldOuterContainer}>
                <div className={classes.textFieldInnerContainer}>
                    <TextField
                        label={addressTextFieldProps.label}
                        text={addressTextFieldProps.text}
                        type={addressTextFieldProps.type}
                        onChangeHandler={addressTextFieldProps.onChangeHandler}
                        width={addressTextFieldProps.width}
                        disabled={addressTextFieldProps.disabled}
                        labelPosition={addressTextFieldProps.labelPosition} />
                </div>
            </div>
            <div className={classes.errorMessageContainer}>
                {isPostalCodeError &&
                    <Typography variant='body1' className={classes.errorMessage}>
                        {String_System_ErrorAddressRequired.find(s => s.key === userState.state.locale)!!.value}
                    </Typography>
                }
            </div>

            <div className={classes.textFieldOuterContainer}>
                <div className={classes.textFieldInnerContainer}>
                    <TextField 
                        label={cityTextFieldProps.label}
                        text={cityTextFieldProps.text}
                        type={cityTextFieldProps.type}
                        onChangeHandler={cityTextFieldProps.onChangeHandler}
                        width={cityTextFieldProps.width}
                        disabled={cityTextFieldProps.disabled}
                        labelPosition={cityTextFieldProps.labelPosition} />
                </div>
            </div>
            <div className={classes.errorMessageContainer}>
                {isPostalCodeError &&
                    <Typography variant='body1' className={classes.errorMessage}>
                        {String_System_ErrorCityRequired.find(s => s.key === userState.state.locale)!!.value}
                    </Typography>
                }
            </div>

            <div className={classes.textFieldOuterContainer}>
                <div className={classes.textFieldInnerContainer}>
                    <TextField 
                        label={postalCodeTextFieldProps.label}
                        text={postalCodeTextFieldProps.text}
                        type={postalCodeTextFieldProps.type}
                        onChangeHandler={postalCodeTextFieldProps.onChangeHandler}
                        width={postalCodeTextFieldProps.width}
                        disabled={postalCodeTextFieldProps.disabled}
                        labelPosition={postalCodeTextFieldProps.labelPosition} />
                </div>
            </div>
            <div className={classes.errorMessageContainer}>
                {isPostalCodeError &&
                    <Typography variant='body1' className={classes.errorMessage}>
                        {String_System_ErrorPostalCodeRequired.find(s => s.key === userState.state.locale)!!.value}
                    </Typography>
                }
            </div>

            <div className={classes.textFieldOuterContainer}>
                <div className={classes.textFieldInnerContainer}>
                    <TextField 
                        type={emailProps.type}
                        label={emailProps.label}
                        text={emailProps.text}
                        width={emailProps.width}
                        disabled={emailProps.disabled}
                        labelPosition={emailProps.labelPosition}
                        onChangeHandler={emailProps.onChangeHandler} />
                </div>
            </div>
            <div className={classes.errorMessageContainer}>
                {isEmailError &&
                    <Typography variant='body1' className={classes.errorMessage}>
                        {String_System_ErrorInvalidEmail.find(s => s.key === userState.state.locale)!!.value}
                    </Typography>
                }
            </div>

            <div className={classes.textFieldOuterContainer}>
                <div className={classes.textFieldInnerContainer}>
                    <PhoneTextField 
                        country={phoneTextFieldProps.country}
                        label={phoneTextFieldProps.label}
                        text={phoneTextFieldProps.text}
                        type={phoneTextFieldProps.type}
                        onChangeHandler={phoneTextFieldProps.onChangeHandler}
                        width={phoneTextFieldProps.width}
                        disabled={phoneTextFieldProps.disabled}
                        labelPosition={phoneTextFieldProps.labelPosition} />
                </div>
            </div>
            <div className={classes.errorMessageContainer}>
                {isPhoneError &&
                    <Typography variant='body1' className={classes.errorMessage}>
                        {String_System_ErrorInvalidPhone.find(s => s.key === userState.state.locale)!!.value}
                    </Typography>
                }
            </div>
        </div>
    );
};

export default ThreeDs;